var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityNonMains128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 64.5029H26.0002",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5531 35.7031H97.6924C100.077 35.7031 102.009 37.4971 102.009 39.7101V89.2962C102.009 91.5092 100.077 93.3031 97.6924 93.3031H68.5531C54.2479 93.3031 42.6514 82.5393 42.6514 69.2614V59.7449C42.6514 46.467 54.2479 35.7031 68.5531 35.7031Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.186 54.9419L82.372 63.8172L73.186 72.6926L64.0001 63.8172L73.186 54.9419Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.009 51.7031H112.733C114.096 51.7031 115.2 53.1358 115.2 54.9031C115.2 56.6704 114.096 58.1031 112.733 58.1031H102.009V51.7031Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.009 70.9033H112.733C114.096 70.9033 115.2 72.336 115.2 74.1033C115.2 75.8706 114.096 77.3033 112.733 77.3033H102.009V70.9033Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9636 51.7031H25.9907V77.3031H43.9636C43.0023 74.7887 42.4791 72.0817 42.4791 69.2614V59.7449C42.4791 56.9245 43.0023 54.2176 43.9636 51.7031Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9907 51.7031V50.8031H25.0907V51.7031H25.9907ZM43.9636 51.7031L44.8042 52.0245L45.2712 50.8031H43.9636V51.7031ZM25.9907 77.3031H25.0907V78.2031H25.9907V77.3031ZM43.9636 77.3031V78.2031H45.2712L44.8042 76.9817L43.9636 77.3031ZM25.9907 52.6031H43.9636V50.8031H25.9907V52.6031ZM26.8907 77.3031V51.7031H25.0907V77.3031H26.8907ZM43.9636 76.4031H25.9907V78.2031H43.9636V76.4031ZM44.8042 76.9817C43.8813 74.5675 43.3791 71.9694 43.3791 69.2614H41.5791C41.5791 72.1941 42.1234 75.0098 43.1229 77.6245L44.8042 76.9817ZM43.3791 69.2614V59.7449H41.5791V69.2614H43.3791ZM43.3791 59.7449C43.3791 57.0369 43.8813 54.4387 44.8042 52.0245L43.1229 51.3817C42.1234 53.9964 41.5791 56.8121 41.5791 59.7449H43.3791Z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityNonMains128);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityNonMains128.eced26b03de7399e3869e341632adb1c.svg";
export { ForwardRef as ReactComponent };